import addresses from "../../api/addresses";

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    editedItem: {
      Id: null,
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      fullAddress: "",
      addressName: "",
      addressType: "Billing",
      fK_Customer: null,
    },
    defaultItem: {
      Id: null,
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      fullAddress: "",
      addressName: "",
      addressType: "Billing",
      fK_Customer: null,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        Id: item.id,
        addressLine1: item.addressLine1,
        addressLine2: item.addressLine2,
        city: item.city,
        state: item.state,
        zipCode: item.zipCode,
        country: item.country,
        fullAddress: item.fullAddress,
        addressName: item.addressName,
        addressType: "" + item.addressType + "",
        fK_Customer: item.fK_Customer,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    setCustomer(state, customer) {
      state.editedItem.fK_Customer = customer;
    },
    setType(state, type) {
      state.editedItem.addressType = type;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return addresses.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    fetchItemByCustomerId({ commit }, data) {
      return addresses.getAddressByCustomerId(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    saveEditedItem({ dispatch, state }) {
      const data = state.editedItem;
      data.addressType = data.addressType == "Billing" ? 0 : 1;
      if (data.Id === null) {
        delete data.Id;
      }
      return addresses.store(state.editedItem).then((response) => {
        const customer = response.data;
        customer.customer = state.editedItem.fK_Customer;
        dispatch("resetEditedItem");
        return customer;
      });
    },
    updateEditedItem({ dispatch, state }) {
      const data = state.editedItem;
      data.addressType = data.addressType == "Billing" ? 0 : 1;
      return addresses.update(state.editedId, data).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    deleteItem(context, id) {
      return addresses.delete(id);
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
